/**
 * @fileoverview Model representing a Google Match
 *
 * @author Dave Sammel (dsammel@yext.com)
 */

export class MatchInfo {
  /**
   * @param {{
   *  externalId: string,
   *  name: string,
   *  addressTokens: !Array<string>,
   *  country: string,
   *  phone: string,
   *  primaryCategoryName: string,
   *  url: string,
   *  existingSyncEntityId: (number | undefined),
   *  isVerified: boolean,
   *  isCurrentMatch: boolean
   * }} params
   */
  constructor(params) {
    /** @type {string} */
    this.externalId = params.externalId;
    /** @type {string} */
    this.name = params.name;
    /** @type {!Array<string>} */
    this.addressTokens = params.addressTokens;
    /** @type {string} */
    this.country = params.country;
    /** @type {string} */
    this.phone = params.phone;
    /** @type {string} */
    this.primaryCategoryName = params.primaryCategoryName;
    /** @type {string} */
    this.url = params.url;
    /** @type {number | undefined} */
    this.existingSyncEntityId = params.existingSyncEntityId;
    /** @type {boolean} */
    this.isVerified = params.isVerified;
    /** @type {boolean} */
    this.isCurrentMatch = params.isCurrentMatch;
  }

  /**
   * @param {!MatchInfoJson} json
   * @return {!MatchInfo}
   */
  static fromJSON(json) {
    return new MatchInfo({
      externalId: json['externalId'],
      name: json['name'],
      addressTokens: json['addressTokens'],
      country: json['country'],
      phone: json['phone'],
      primaryCategoryName: json['primaryCategoryName'],
      url: json['url'],
      existingSyncEntityId: json['existingSyncEntityId'],
      isVerified: json['isVerified'],
      isCurrentMatch: json['isCurrentMatch'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  externalId: string,
 *  name: string,
 *  addressTokens: !Array<string>,
 *  country: string,
 *  phone: string,
 *  primaryCategoryName: string,
 *  url: string,
 *  existingSyncEntityId: (number | undefined),
 *  isVerified: boolean
 * }}
 */
export var MatchInfoJson;
